import React from 'react';
import { useDispatch } from 'react-redux';
import { ModalBody } from '../../../CommonComponents/OPL/Modal/ModalBody';
import { ModalFooter } from '../../../CommonComponents/OPL/Modal/ModalFooter';
import { Button } from '../../../CommonComponents/OPL/Button/Button';
import { setDeletePaymentConfirmationOpenState, setIsEditing, setPaymentMethod } from '../../state';
import { CreditCardSaved } from './components/CreditCardSaved';
import { AchSaved } from './components/AchSaved';
import { DeletePaymentConfirmation } from './components/DeletePaymentConfirmation';
import { PaymentOptionsDTO, usePaymentQuery } from '../../api/usePaymentQuery';

export const PaymentSaved: React.FC = () => {
  const { data } = usePaymentQuery();

  const dispatch = useDispatch();

  if (!data) {
    return null;
  }

  const { currentPaymentOption } = data;

  return (
    <>
      <ModalBody>
        {currentPaymentOption === PaymentOptionsDTO.CreditCard && <CreditCardSaved />}

        {currentPaymentOption === PaymentOptionsDTO.ACH && <AchSaved />}
      </ModalBody>

      <ModalFooter>
        <Button
          variant="subtleInactive"
          onClick={() => dispatch(setDeletePaymentConfirmationOpenState(true))}
          mr="12"
        >
          Clear
        </Button>

        <Button
          variant="primary"
          onClick={() => {
            dispatch(setPaymentMethod(data.currentPaymentOption));
            dispatch(setIsEditing(true));
          }}
        >
          Edit
        </Button>
      </ModalFooter>

      <DeletePaymentConfirmation />
    </>
  );
};
